import { auth } from './db.js';
import {
    createStore
} from 'vuex';

const store = createStore({
    state() {
        return {
            "appConfig": JSON.parse(import.meta.env.VITE_APP_CONFIG),
            "user": null,
            "impersonation": null,
            "failedUser": false,
            "sigMatrixViewingNew": false,
            "sideNavOpen": true,
            "tenantClaim": null  // Cached tenant claim for current tenant (sync access)
        }
    },
    mutations: {
        save(state, data) {
            
            
            Object.entries(data).forEach(([key, value]) => {
                
                
                state[key] = value;
            });
        },
        signout(state) {
            state.user = null;
            state.notifications = null;
            state.impersonation = null;
            state.failedUser = true;
            state.tenantClaim = null;
        },
        setTenantClaim(state, claim) {
            state.tenantClaim = claim;
        }
    },
    getters: {
        userName(state) {
            return state.user?.Basic?.name
                || state.user?.FullName
                || state.user?.User?.FullName
                || state.user?.Email
                || state.user?.User?.Email
                || "Unknown";
        },
        user(state) {
            return state.user;
        },
        userID(state) {
            if (state.user?.Basic) return state.user.Basic.key || state.user.Basic.ID;

            // External profiles are loaded from canonical UID paths by authState.
            // Match the active Auth user (the target during impersonation), never AccountID.
            const uid = auth.currentUser?.uid;
            return state.user && !state.failedUser && uid && state.user.ID === uid
                ? uid
                : "Unknown";
        },
        userObject(state) {
            return {
                "Name": state.user && state.user.Basic ? state.user.Basic.name : "Unknown",
                "ID": state.user && state.user.Basic ? state.user.Basic.key : "Unknown"
            }
        },
        isUserAdmin(state) {
            return state.user?.Security?.General?.UserAdmin === true;
        },
        authenticated(state) {
            return !!state.user
        },
        recents(state) {
            return Object.entries(state.user.Recents || {});
        },
        currency(state) {
            return state.appConfig.currency || "£";
        },
        hasInternalClass(state) {
            return state.tenantClaim?.internal === true;
        },
        showBetaFeatures(state) {
            return state.user?.Basic?.showBetaFeatures === true;
        }
    }
});

export default store;
